module.exports = __webpack_public_path__ + "img/reduced-membership.a4a40ad8.png";